/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderInschrijvenGridCard = () => {
	const parentClass = '.po-grid-slider-wrapper';

	if (!$(parentClass).length) return;

	const initSwiper = function ($container) {
		const $slider = $container.find('.po-grid-slider');
		if (!$slider.length) return;

		if ($slider.data('swiper') || $slider.data('swiper-initializing')) return;
		$slider.data('swiper-initializing', true);

		const slidesDesktop = parseInt($container.data('slides-desktop')) || 3;
		const slidesTablet  = parseInt($container.data('slides-tablet')) || 2;
		const slidesMobile  = parseInt($container.data('slides-mobile')) || 1;

		const params = {
			slidesPerView: slidesDesktop,
			spaceBetween: 20,
			loop: false,
			watchOverflow: true,
			grabCursor: true,
			watchSlidesProgress: true,
			observer: true,
			observeParents: true,
			pagination: {
				el: $container.find('.po-grid-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $container.find('.po-grid-next')[0],
				prevEl: $container.find('.po-grid-prev')[0],
			},
			breakpoints: {
				0: {
					slidesPerView: slidesMobile,
					spaceBetween: 16,
				},
				600: {
					slidesPerView: slidesTablet,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: slidesDesktop,
					spaceBetween: 20,
				},
			},
		};

		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.utils && elementorFrontend.utils.swiper) {
			const asyncSwiper = elementorFrontend.utils.swiper;
			new asyncSwiper($slider, params).then(function (newSwiperInstance) {
				$slider.data('swiper', newSwiperInstance);
				$slider.removeData('swiper-initializing');
			});
		} else if (typeof Swiper !== 'undefined') {
			const newSwiper = new Swiper($slider[0], params);
			$slider.data('swiper', newSwiper);
			$slider.removeData('swiper-initializing');
		} else {
			$slider.removeData('swiper-initializing');
		}
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/inschrijven-grid-card.default',
				function ($element) {
					initSwiper($element);
				}
			);
		}
	});

	$(parentClass).each(function () {
		initSwiper($(this));
	});
};

try {
	sliderInschrijvenGridCard();
} catch (error) {
	console.warn(error);
}
